"use client"

import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import React from "react"
import { useForm } from "react-hook-form"

type ManualContactFormValues = {
  email: string
  phone: string
}

type ManualContactFormProps = {
  initialEmail?: string | null
  initialPhone?: string | null
  onSave: (values: ManualContactFormValues) => Promise<void> | void
  onCancel: () => void
}

export const ManualContactForm = React.memo(function ManualContactForm({
  initialEmail,
  initialPhone,
  onSave,
  onCancel,
}: ManualContactFormProps) {
  const { register, handleSubmit } = useForm<ManualContactFormValues>({
    defaultValues: {
      email: initialEmail ?? "",
      phone: initialPhone ?? "",
    },
  })

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium text-muted-foreground">
          Contact Information
        </span>
        <Button
          variant="ghost"
          size="sm"
          onClick={onCancel}
          className="h-6 text-xs"
          type="button"
        >
          Cancel
        </Button>
      </div>

      <form
        onSubmit={handleSubmit(onSave)}
        className="p-4 bg-muted/50 dark:bg-muted/20 border border-border rounded-lg space-y-4"
      >
        <div className="text-sm font-medium text-foreground">
          Enter Contact Manually
        </div>

        <div className="space-y-3">
          <div className="space-y-1.5">
            <Label className="text-xs text-muted-foreground">Email</Label>
            <Input
              type="email"
              placeholder="email@example.com"
              {...register("email")}
              className="bg-background text-foreground"
            />
          </div>

          <div className="space-y-1.5">
            <Label className="text-xs text-muted-foreground">Phone</Label>
            <Input
              type="tel"
              placeholder="+1 555-0123"
              {...register("phone")}
              className="bg-background text-foreground"
            />
          </div>
        </div>

        <Button type="submit" className="w-full">
          Save Contact Info
        </Button>
      </form>
    </div>
  )
})